export default function EmptyState({
  title = "Nothing found.",
  subtitle = "",
}) {
  return (
    <div
      style={{
        color: "#64748b",
        fontWeight: 800,
        padding: 12,
        borderRadius: 12,
        background: "#f8fafc",
        border: "1px solid #e2e8f0",
      }}
    >
      <div>{title}</div>
      {subtitle ? (
        <div style={{ marginTop: 4, fontSize: 12, fontWeight: 700 }}>
          {subtitle}
        </div>
      ) : null}
    </div>
  );
}